import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import DropdownSelect from '../../components/DropdownSelect';
import { StyledButton } from './styled';
import { PageWrapper, Title } from '../common/styled';

interface CashFlowStatementPageProps {
  academicYear: string;
  school: string;
  academicYearOptions: { label: string; value: string }[];
  schoolOptions: { label: string; value: string }[];
  loading: boolean;
  isSchoolLoading: boolean;
  onAcademicYearChange: (value: string) => void;
  onSchoolChange: (value: string) => void;
  onDownloadReport: () => void;
  isAuthorized: boolean;
}

const CashFlowStatementPage: React.FC<CashFlowStatementPageProps> = ({
  academicYear,
  school,
  academicYearOptions,
  schoolOptions,
  loading,
  isSchoolLoading,
  onAcademicYearChange,
  onSchoolChange,
  onDownloadReport,
  isAuthorized
}) => {
  return (
    <>
      <Title>Cash Flow Statement</Title>
      <PageWrapper>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            width: '100%',
            alignItems: 'center'
          }}
        >
          <DropdownSelect
            label='Academic Year'
            placeholder='Select Academic Year'
            name='academicYear'
            value={academicYear}
            options={academicYearOptions}
            onChange={(e) => onAcademicYearChange(e.target.value as string)}
          />
          <DropdownSelect
            label='School'
            name='school'
            value={school}
            options={schoolOptions}
            onChange={(e) => onSchoolChange(e.target.value as string)}
            placeholder='Select School'
            loading={isSchoolLoading}
          />
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              width: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}
          >
            <StyledButton
              onClick={onDownloadReport}
              disabled={
                loading ||
                !isAuthorized ||
                academicYearOptions.length === 0 ||
                schoolOptions.length === 0
              }
            >
              {loading ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Download Report'
              )}
            </StyledButton>
          </Box>
        </Box>
      </PageWrapper>
    </>
  );
};

export default CashFlowStatementPage;
